import { render } from "./LookId.vue?vue&type=template&id=fb936132&scoped=true&ts=true"
import script from "./LookId.vue?vue&type=script&setup=true&lang=ts"
export * from "./LookId.vue?vue&type=script&setup=true&lang=ts"

import "./LookId.vue?vue&type=style&index=0&id=fb936132&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb936132"],['__file',"src/views/me/LookId.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb936132"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb936132', __exports__)) {
    console.log('reload')
    api.reload('fb936132', __exports__)
  }
  
  module.hot.accept("./LookId.vue?vue&type=template&id=fb936132&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('fb936132', render)
  })

}


export default __exports__